import React, { useEffect, useState } from "react";
import EditIcon from "../../assets/icons/edit.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import MenuIcon from "../../assets/icons/menu.svg";

import Sidebar from "../../components/Sidebar/Sidebar";
import { contentService } from "../../services/content.service";

import "./ContentAdmin.css";
import "../../utils/animate.css";
import ModalAddFaq from "../../components/ModalAddFaq/ModalAddFaq";
import ModalEditFaq from "../../components/ModalEditFaq/ModalEditFaq";
import ModalAddSocial from "../../components/ModalAddSocial/ModalAddSocial";
import ModalEditSocial from "../../components/ModalEditSocial/ModalEditSocial";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import { closeModal, showModal } from "../../utils/functions/modal";
import { getSocialIcon } from "../../utils/functions/socials";

const EMPTY_BANK_DATA = {
  cbu: "",
  alias: "",
  banco: "",
  nombre_cuenta: "",
  email: "",
  telefono: "",
};

const ContentAdmin = () => {
  const [tab, setTab] = useState("banco");

  const [bankData, setBankData] = useState(EMPTY_BANK_DATA);
  const [faqs, setFaqs] = useState(undefined);
  const [socials, setSocials] = useState(undefined);

  const [testEmail, setTestEmail] = useState("");
  const [testType, setTestType] = useState("transferencia");
  const [testDebug, setTestDebug] = useState(null);

  const [faqEdit, setFaqEdit] = useState();
  const [socialEdit, setSocialEdit] = useState();
  // Id del elemento que está esperando confirmación de borrado. Es uno solo
  // para FAQs y redes porque nunca hay dos diálogos abiertos a la vez: la
  // acción a ejecutar la define `message.action`.
  const [idToDelete, setIdToDelete] = useState();
  const [message, setMessage] = useState(undefined);

  const getBankData = async () => {
    const response = await contentService.getBankData();
    if (response.status === 200 && response.data.datosBancarios) {
      setBankData(response.data.datosBancarios);
    }
  };

  const getAllFaqs = async () => {
    const response = await contentService.getAllFaqs();
    if (response.status === 200) {
      setFaqs(response.data.faqs);
    }
  };

  const getAllSocials = async () => {
    const response = await contentService.getAllSocials();
    if (response.status === 200) {
      setSocials(response.data.redes);
    }
  };

  useEffect(() => {
    getBankData();
    getAllFaqs();
    getAllSocials();
  }, []);

  const showSidebar = () => {
    document
      .querySelector(".container-sidebar")
      ?.classList.add("show-sidebar");
  };

  const handleChangeBankData = (field) => (e) => {
    setBankData({ ...bankData, [field]: e.target.value });
  };

  const handleSubmitBankData = async (e) => {
    e.preventDefault();

    showModal(".container-modal-confirm");
    setMessage({ description: "Guardando datos bancarios...", status: 1000 });

    const response = await contentService.editBankData(bankData);

    setTimeout(() => {
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
      setTimeout(() => {
        closeModal(".container-modal-confirm");
      }, 1500);
    }, 1000);
  };

  // El envío tarda lo que tarde el SMTP, así que acá no hay delay artificial y
  // el modal queda abierto hasta que el admin lo cierra: si falla, el motivo del
  // error es lo que se vino a ver.
  const handleSubmitTestEmail = async (e) => {
    e.preventDefault();

    showModal(".container-modal-confirm");
    setMessage({ description: "Enviando mail de prueba...", status: 1000 });
    setTestDebug(null);

    try {
      const response = await contentService.sendTestEmail({
        email: testEmail,
        tipo: testType,
      });
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
      // Si el SMTP falló, el backend manda la conversación con el servidor.
      if (response.data.debug?.length) {
        setTestDebug(response.data.debug);
      }
    } catch (error) {
      setMessage({
        description: "No se pudo contactar al servidor para enviar el mail",
        status: 500,
      });
    }
  };

  const showModalEditFaq = (faq) => {
    setFaqEdit(faq);
    showModal(".container-modal-edit-faq");
  };

  const showModalDeleteFaq = (faq) => {
    showModal(".container-modal-confirm");

    setIdToDelete(faq.id);
    setMessage({
      description: `¿Estás seguro de eliminar la pregunta "${faq.titulo}"?`,
      status: 300,
      action: deleteFaq,
    });
  };

  const deleteFaq = async (id) => {
    setMessage({ description: "Eliminando pregunta...", status: 1000 });
    const response = await contentService.deleteFaq(id);
    setTimeout(async () => {
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
      if (response.data.status === 200) {
        await getAllFaqs();
      }
      setTimeout(() => {
        closeModal(".container-modal-confirm");
      }, 2000);
    }, 1000);
  };

  const showModalEditSocial = (social) => {
    setSocialEdit(social);
    showModal(".container-modal-edit-social");
  };

  const showModalDeleteSocial = (social) => {
    showModal(".container-modal-confirm");

    setIdToDelete(social.id);
    setMessage({
      description: `¿Estás seguro de eliminar la red social "${social.nombre}"?`,
      status: 300,
      action: deleteSocial,
    });
  };

  const deleteSocial = async (id) => {
    setMessage({ description: "Eliminando red social...", status: 1000 });
    const response = await contentService.deleteSocial(id);
    setTimeout(async () => {
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
      if (response.data.status === 200) {
        await getAllSocials();
      }
      setTimeout(() => {
        closeModal(".container-modal-confirm");
      }, 2000);
    }, 1000);
  };

  return (
    <>
      <ModalConfirm
        message={message}
        actionConfirm={message?.action}
        idSale={idToDelete}
      />
      <ModalEditFaq setMessage={setMessage} faq={faqEdit} onSuccess={getAllFaqs} />
      <ModalAddFaq setMessage={setMessage} onSuccess={getAllFaqs} />
      <ModalEditSocial
        setMessage={setMessage}
        social={socialEdit}
        onSuccess={getAllSocials}
      />
      <ModalAddSocial setMessage={setMessage} onSuccess={getAllSocials} />

      <div className="container-content-admin">
        <Sidebar />
        <div className="content-admin">
          <div className="head-admin">
            <button className="btn-menu" onClick={() => showSidebar()}>
              <img src={MenuIcon} alt="" />
            </button>
            <h1 className="animate fadeIn">CONTENIDO</h1>
          </div>

          <div className="content-tabs animate fadeIn">
            <button
              className={`tab-btn ${tab === "banco" ? "active" : ""}`}
              onClick={() => setTab("banco")}
            >
              Datos Bancarios
            </button>
            <button
              className={`tab-btn ${tab === "faqs" ? "active" : ""}`}
              onClick={() => setTab("faqs")}
            >
              Preguntas Frecuentes
            </button>
            <button
              className={`tab-btn ${tab === "redes" ? "active" : ""}`}
              onClick={() => setTab("redes")}
            >
              Redes Sociales
            </button>
            <button
              className={`tab-btn ${tab === "emails" ? "active" : ""}`}
              onClick={() => setTab("emails")}
            >
              Emails
            </button>
          </div>

          {tab === "banco" && (
            <form className="admin-form animate fadeIn" onSubmit={handleSubmitBankData}>
              <div className="form-row">
                <div className="input">
                  <label htmlFor="cbu">CBU</label>
                  <input
                    type="text"
                    id="cbu"
                    required
                    value={bankData.cbu}
                    onChange={handleChangeBankData("cbu")}
                  />
                </div>
                <div className="input">
                  <label htmlFor="alias">Alias</label>
                  <input
                    type="text"
                    id="alias"
                    required
                    value={bankData.alias}
                    onChange={handleChangeBankData("alias")}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input">
                  <label htmlFor="banco">Banco</label>
                  <input
                    type="text"
                    id="banco"
                    required
                    value={bankData.banco}
                    onChange={handleChangeBankData("banco")}
                  />
                </div>
                <div className="input">
                  <label htmlFor="nombre_cuenta">Titular</label>
                  <input
                    type="text"
                    id="nombre_cuenta"
                    required
                    value={bankData.nombre_cuenta}
                    onChange={handleChangeBankData("nombre_cuenta")}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input">
                  <label htmlFor="email">Email de contacto</label>
                  <input
                    type="email"
                    id="email"
                    value={bankData.email}
                    onChange={handleChangeBankData("email")}
                  />
                </div>
                <div className="input">
                  <label htmlFor="telefono">Teléfono de contacto</label>
                  <input
                    type="text"
                    id="telefono"
                    value={bankData.telefono}
                    onChange={handleChangeBankData("telefono")}
                  />
                </div>
              </div>
              <span className="form-hint">
                Esto es lo que ve el cliente al elegir pagar por transferencia en el checkout.
              </span>
              <button className="btn-add-product" type="submit">
                GUARDAR CAMBIOS
              </button>
            </form>
          )}

          {tab === "faqs" && (
            <>
              <div className="head-tab animate fadeIn">
                <button
                  onClick={() => showModal(".container-modal-add-faq")}
                  className="btn-add-product"
                >
                  AGREGAR
                </button>
              </div>
              <div className="table-content">
                {faqs && faqs.length > 0 && (
                  <table cellSpacing="0">
                    <thead className="head-table animate fadeIn">
                      <tr>
                        <th>Orden</th>
                        <th>Pregunta</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {faqs.map((faq, key) => (
                        <tr
                          key={faq.id}
                          style={{ animationDelay: `${Math.min(key, 8) * 0.06}s` }}
                        >
                          <td>{faq.orden}</td>
                          <td className="text-left-cell">{faq.titulo}</td>
                          <td>
                            <button
                              className="action"
                              onClick={() => showModalEditFaq(faq)}
                            >
                              <img src={EditIcon} alt="" />
                            </button>
                            <button
                              className="action"
                              onClick={() => showModalDeleteFaq(faq)}
                            >
                              <img src={DeleteIcon} alt="" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {faqs && faqs.length === 0 && (
                  <div className="empty-content">
                    <p>No hay preguntas frecuentes cargadas</p>
                  </div>
                )}
                {faqs === undefined && <div className="empty-content"></div>}
              </div>
            </>
          )}

          {tab === "redes" && (
            <>
              <div className="head-tab animate fadeIn">
                <button
                  onClick={() => showModal(".container-modal-add-social")}
                  className="btn-add-product"
                >
                  AGREGAR
                </button>
              </div>
              <div className="table-content">
                {socials && socials.length > 0 && (
                  <table cellSpacing="0">
                    <thead className="head-table animate fadeIn">
                      <tr>
                        <th>Orden</th>
                        <th>Icono</th>
                        <th>Nombre</th>
                        <th>Link</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {socials.map((social, key) => (
                        <tr
                          key={social.id}
                          style={{ animationDelay: `${Math.min(key, 8) * 0.06}s` }}
                        >
                          <td>{social.orden}</td>
                          <td>
                            <img
                              className="social-icon"
                              src={getSocialIcon(social.icono)}
                              alt=""
                            />
                          </td>
                          <td className="text-left-cell">{social.nombre}</td>
                          <td className="text-left-cell">
                            <a
                              className="social-link"
                              href={social.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {social.url}
                            </a>
                          </td>
                          <td>
                            <button
                              className="action"
                              onClick={() => showModalEditSocial(social)}
                            >
                              <img src={EditIcon} alt="" />
                            </button>
                            <button
                              className="action"
                              onClick={() => showModalDeleteSocial(social)}
                            >
                              <img src={DeleteIcon} alt="" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {socials && socials.length === 0 && (
                  <div className="empty-content">
                    <p>No hay redes sociales cargadas</p>
                  </div>
                )}
                {socials === undefined && <div className="empty-content"></div>}
              </div>
              <span className="form-hint">
                Esto es lo que se muestra en el footer de la web.
              </span>
            </>
          )}

          {tab === "emails" && (
            <form
              className="admin-form test-email-form animate fadeIn"
              onSubmit={handleSubmitTestEmail}
            >
              <div className="form-row">
                <div className="input">
                  <label htmlFor="test-email">Enviar a</label>
                  <input
                    type="email"
                    id="test-email"
                    required
                    placeholder="tucorreo@gmail.com"
                    value={testEmail}
                    onChange={(e) => setTestEmail(e.target.value)}
                  />
                </div>
                <div className="input">
                  <label htmlFor="test-type">Tipo de mail</label>
                  <select
                    id="test-type"
                    value={testType}
                    onChange={(e) => setTestType(e.target.value)}
                  >
                    <option value="transferencia">
                      Pedido por transferencia
                    </option>
                    <option value="compra">Compra pagada</option>
                  </select>
                </div>
              </div>
              <span className="form-hint">
                Manda el mail real, con la misma casilla y la misma plantilla que
                usa el checkout, pero con un pedido de ejemplo. No registra
                ninguna venta ni toca el stock.
              </span>
              {testType === "transferencia" && (
                <span className="form-hint">
                  Los datos bancarios que se ven en el mail son los de la pestaña
                  "Datos Bancarios".
                </span>
              )}
              <button className="btn-add-product" type="submit">
                ENVIAR PRUEBA
              </button>

              {testDebug && (
                <div className="smtp-debug">
                  <span className="form-hint">
                    Conversación con el servidor de correo:
                  </span>
                  <pre>{testDebug.join("\n")}</pre>
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default ContentAdmin;
